import React, { useState } from "react";
import { Modal } from "react-bootstrap";
// import DOMPurify from "dompurify";

export default function NotificationView({ show, onHide, notificationData }) {
  return (
    <Modal show={show} onHide={onHide} centered contentClassName="custom-modal-bg">
      <h3 className="px-2 py-3" style={{ color: "#a6f9fe" }}>Notification</h3>
      <div className="container py-3">
        {notificationData.image && (
          <div className="d-flex justify-content-center my-4">
            <img
              src={notificationData.image}
              enableZoom={true}
              classes="mx-auto img-fluid object-fit-cover aspect-ratio-1x1 w-100"
            />
          </div>
        )}

        <div className="confirmation-container">
          <div
            className="confirmation-header fw-bold text-start mb-2"
            style={{ fontSize: "22px", lineHeight: "1.75" }}
          >
            {notificationData?.title}
          </div>

          <div
            className="confirmation-body text-muted text-start mb-4"
            style={{
              fontSize: "14px",
              lineHeight: "1.5",
              whiteSpace: "pre-wrap",
            }}
          >
            <div className="newptag" style={{ lineHeight: "1px" }}>
              <div
                className="m-0 subtext"
                style={{color:"#fff"}}
                dangerouslySetInnerHTML={{ __html: notificationData?.message }}
              />
            </div>
          </div>

          {!notificationData.buttonText && (
            <div className="d-grid gap-2">
              <button type="button" className="btn btn-primary fw-bold">
                Become a Member
              </button>
            </div>
          )}

          {notificationData?.buttonText && (
            <div className="d-grid gap-2">
              <button
                type="button"
                className="btn fw-bold"
                style={{
                  backgroundColor: "#a6f9fe",
                  color: "#222222",
                  borderColor: "none",
                }}
              >
                {notificationData?.buttonText}
              </button>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
